<script setup>
import { onBeforeMount, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Breadcrumb from "@components/layouts/breadcrumb/Breadcrumb.vue";
import CustomSelect from "@components/form/CustomSelect.vue";
import ProductCard from "@components/cards/ProductCard.vue";
import { useInventoryStore } from "@composables/use_inventory_store";
import { useShoppingCartStore } from "@composables/use_shopping_cart_store";

const route = useRoute();
const router = useRouter();
const {
  searching,
  categories,
  subcategories,
  products,
  loadingProducts,
  productsSearchResult,
  crumbs,
  getCrumbsCat,
  getCrumbsSub,
  getSubcategories,
  getProductBySubcategory,
  getProductByCategory,
  clearSearch,
  searchingProducts,
} = useInventoryStore();
const { updateShoppingCart } = useShoppingCartStore();
const categoryId = ref();
const categorySlug = ref();
const subcategoryId = ref();
const subcategorySlug = ref();
var showVerTodas = ref(false);
var oldProducts = ref({});
var initialResolution;

watch(categories, async () => {
  console.log("categories change");
  getCrumbsSub(categoryId.value, subcategoryId.value);
});
watch(products, async () => {
  console.log("prod result change");
});

onBeforeMount(() => {
  console.log("subcategory mounted");
  window.scrollTo(0, 0);

  let category_id_slug = route.params.category_id_slug.split("_");
  categoryId.value = category_id_slug[0];
  categorySlug.value = category_id_slug[1].toUpperCase();

  let subcategory_id_slug = route.params.subcategory_id_slug.split("_");
  subcategoryId.value = subcategory_id_slug[0];
  subcategorySlug.value = subcategory_id_slug[1].toUpperCase();

  clearSearch();

  getSubcategories(categoryId.value);
  getProductBySubcategory(categoryId.value, subcategoryId.value);
  getCrumbsSub(categoryId.value, subcategoryId.value);
});

onMounted(() => {
  initialResolution = screen.width;
  window.addEventListener("resize", () => {
    console.log("INITIAL RESOLUTION: " + initialResolution);
    console.log("CURRENT RESOLUTION: " + screen.width);
    if (initialResolution !== screen.width) {
      console.log("SCREEN RESOLUTION CHANGED");
      window.location.reload();
    }
  });
});

function changeCategory(category) {
  getCrumbsCat(category.id);
  router.push({
    name: "Category",
    params: {
      category_id_slug: `${category.id}_${category.slug}`,
    },
  });
}

async function verTodas(page) {
  let next_page = parseInt(page) + 1;
  showVerTodas.value = true;
  getCrumbsCat(categoryId.value);

  if (next_page != 1 && next_page != 2) {
    products.value.forEach((product) => {
      oldProducts.value.push(product);
    });
  }

  await getProductByCategory(categoryId.value, next_page);

  if (next_page == 1) {
    oldProducts.value = JSON.parse(JSON.stringify(products.value));
  }
  let element = document.getElementById("mas_resultados");
  if (element) {
    element.scrollIntoView({ block: "center", behavior: "smooth" });
  }
}

async function changeSubcategory(subcategory) {
  showVerTodas.value = false;
  getCrumbsSub(categoryId.value, subcategory.id);
  router.replace({
    name: "Subcategory",
    params: {
      category_id_slug: `${categoryId.value}_${categorySlug.value}`,
      subcategory_id_slug: `${subcategory.id}_${subcategory.slug}`,
    },
  });

  subcategorySlug.value = subcategory.slug;
  await getProductBySubcategory(categoryId.value, subcategory.id);

  subcategories.value.forEach((sub) => {
    if (sub.id == subcategory.id) {
      subcategorySlug.value = sub.name;
    }
  });
}
function tapOnProduct(product) {
  router.push({
    name: "ProductDetails",
    params: {
      slug: product.slug,
    },
  });
}
function addToCart(data) {
  updateShoppingCart(data.product, data.qtty, data.ppId, data.Presentacion);
}
</script>

<template>
  <div style="margin: 100px"></div>
  <!-- Breadcrumb -->
  <div
    v-if="
      crumbs.length &&
      (!searching ||
        productsSearchResult.length == 0 ||
        typeof products[0] == 'undefined')
    "
    class="w-100"
  >
    <div class="row m-0 justify-content-between">
      <Breadcrumb :crumbs="crumbs" />
    </div>
  </div>

  <!-- Category filters -->
  <div
    v-if="
      !searching ||
      productsSearchResult.length == 0 ||
      typeof products[0] == 'undefined'
    "
    class="mb-2 w-100"
  >
    <div class="row m-0 justify-filters">
      <div v-if="categories.length" class="col-auto">
        <CustomSelect
          :label="'Categoría'"
          :items="categories"
          :default="categoryId"
          @onselect="changeCategory"
        />
      </div>
      <div v-if="subcategories.length" class="col-auto">
        <CustomSelect
          :label="'Subategoría'"
          :items="subcategories"
          :default="subcategoryId"
          from="subcategories"
          @onselect="changeSubcategory"
          @onvertodas="verTodas(0)"
        />
      </div>
    </div>

    <div
      v-if="!searching && productsSearchResult.length == 0"
      class="px-5 my-3 w-100"
    >
      <div class="row m-0 justify-content-center">
        <div v-if="!showVerTodas" class="col-auto fw-bold fs-4">
          {{ crumbs.length > 0 ? crumbs[1].title : "" }}
        </div>
        <div v-else class="col-auto fw-bold fs-4">
          Productos de la Categoría
        </div>
      </div>
    </div>
  </div>

  <div v-if="!searching">
    <!-- Products -->
    <div
      v-if="
        !loadingProducts &&
        products.length != 0 &&
        typeof products[0] != 'undefined'
      "
      class="row mx-0 justify-content-center my-5 px-1 w-100"
    >
      <div class="row">
        <div
          v-if="
            typeof products[0] != 'undefined' && products[0].current_page > 1
          "
          v-for="(product, index) in oldProducts"
          :key="`prod_card_${index}`"
          class="col-6 p-0 col-sm-6 col-md-5 col-lg-4 col-xl-3"
        >
          <ProductCard
            :product="product"
            @ontap="tapOnProduct"
            @onaddtocart="addToCart"
          />
        </div>

        <div
          v-if="
            typeof products[0] != 'undefined' && products[0].current_page > 1
          "
          class="text-center mt-5"
          id="mas_resultados"
        >
          <hr />
          <h5>Más resultados</h5>
          <hr />
        </div>

        <div
          v-for="(product, index) in products"
          :key="`prod_card_${index}`"
          class="col-6 p-0 col-sm-6 col-md-5 col-lg-4 col-xl-3"
        >
          <ProductCard
            :product="product"
            @ontap="tapOnProduct"
            @onaddtocart="addToCart"
          />
        </div>

        <div
          v-if="
            typeof products[0] != 'undefined' &&
            products[0].current_page < products[0].last_page
          "
          class="my-5 col-12"
        >
          <div class="ZFiwCf border">
            <span class="LGwnxb">
              <span
                class="PBBEhf"
                @click.stop="verTodas(products[0].current_page)"
                >Más resultados
              </span>
            </span>
            <span
              class="w2fKdd z1asCe"
              style="height: 20px; line-height: 20px; width: 20px"
              ><svg
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                ></path>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="searchingProducts" class="col-12 m-auto p-auto text-center p-5">
      <div class="col-12 m-auto p-auto text-center p-5">
        <h5>
          <div class="spinner-border mt-1 ml-2" role="status">
            <span class="sr-only"></span>
          </div>
          Cargando datos...
        </h5>
      </div>
    </div>
    <div
      v-if="
        !searchingProducts &&
        (products.length == 0 || typeof products[0] == 'undefined')
      "
      class="col-12 m-auto p-auto text-center p-5"
    >
      <h5>No se encontraron datos</h5>
    </div>
  </div>

  <!-- Search result -->
  <div v-else>
    <div>
      <!-- No se econtraron datos -->
      <div
        v-if="
          (productsSearchResult.length == 0 ||
            typeof products[0] == 'undefined') &&
          !searchingProducts
        "
        class="col-12 m-auto p-auto text-center p-5"
      >
        <div class="row m-0 justify-content-center py-3">
          <div class="col-auto fw-bold fs-4">RESULTADO DE LA BÚSQUEDA</div>
        </div>
        <h5>No se encontraron datos</h5>
      </div>
      <div
        v-if="searchingProducts"
        class="col-12 m-auto p-auto text-center p-5"
      >
        <h5>
          <div class="spinner-border mt-1 ml-2" role="status">
            <span class="sr-only"></span>
          </div>
          Cargando datos...
        </h5>
      </div>
    </div>
    <!-- END No se econtraron datos -->
    <div
      v-if="
        (productsSearchResult.length > 0 ||
          typeof products[0] != 'undefined') &&
        !searchingProducts
      "
      class="row mx-0 justify-content-center my-2 px-1 w-100"
    >
      <div class="row m-0 justify-content-center py-3">
        <div class="col-auto fw-bold fs-4">RESULTADO DE LA BÚSQUEDA</div>
      </div>
      <div
        class="col-6 p-0 col-sm-6 col-md-5 col-lg-4 col-xl-3"
        v-for="(product, index) in productsSearchResult"
        :key="`prod_res_${index}`"
      >
        <ProductCard
          :product="product"
          @ontap="tapOnProduct"
          @onaddtocart="addToCart"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.justify-filters {
  justify-content: flex-end;
}

@media (max-width: 600px) {
  .justify-filters {
    justify-content: center;
  }
}

.ZFiwCf {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  font-size: 14px;
  font-family: Roboto, arial, sans-serif;
  font-weight: 400;
  width: 100%;
  max-width: 300px;
  height: 36px;
  border-radius: 18px;
  outline: 1px solid transparent;
  background-color: #f1f3f4;
}

.ZFiwCf :hover {
  cursor: pointer;
}

.LGwnxb {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto;
  padding-left: 0;
  padding-right: 8px;
  max-width: 200px;
  color: #202124;
}
.PBBEhf,
.SKsNHb .iInZTe {
  display: unset;
}

.PBBEhf:hover {
  cursor: pointer;
}
</style>
